/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quicktools_Tab_TagsInputs */

const en_quicktools_tab_tags = /** @type {(inputs: Quicktools_Tab_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const fr_quicktools_tab_tags = /** @type {(inputs: Quicktools_Tab_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const de_quicktools_tab_tags = /** @type {(inputs: Quicktools_Tab_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const it_quicktools_tab_tags = /** @type {(inputs: Quicktools_Tab_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etichette`)
};

const ru_quicktools_tab_tags = /** @type {(inputs: Quicktools_Tab_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Теги`)
};

const es_quicktools_tab_tags = /** @type {(inputs: Quicktools_Tab_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquetas`)
};

const zh_cn2_quicktools_tab_tags = /** @type {(inputs: Quicktools_Tab_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标签`)
};

const ja_quicktools_tab_tags = /** @type {(inputs: Quicktools_Tab_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグ`)
};

const hi_quicktools_tab_tags = /** @type {(inputs: Quicktools_Tab_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टैग`)
};

const pt_pt2_quicktools_tab_tags = /** @type {(inputs: Quicktools_Tab_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquetas`)
};

/**
* | output |
* | --- |
* | "Tags" |
*
* @param {Quicktools_Tab_TagsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quicktools_tab_tags = /** @type {((inputs?: Quicktools_Tab_TagsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quicktools_Tab_TagsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_quicktools_tab_tags(inputs)
	if (locale === "de") return de_quicktools_tab_tags(inputs)
	if (locale === "it") return it_quicktools_tab_tags(inputs)
	if (locale === "ru") return ru_quicktools_tab_tags(inputs)
	if (locale === "es") return es_quicktools_tab_tags(inputs)
	if (locale === "zh-CN") return zh_cn2_quicktools_tab_tags(inputs)
	if (locale === "ja") return ja_quicktools_tab_tags(inputs)
	if (locale === "hi") return hi_quicktools_tab_tags(inputs)
	if (locale === "pt-PT") return pt_pt2_quicktools_tab_tags(inputs)
	return en_quicktools_tab_tags(inputs)
});